/* Kwiqrank Theme — vanilla JS, no dependencies. Loaded with `defer`. */
(() => {
  'use strict';

  const T = window.theme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = {
    get(k, d) { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* storage unavailable */ } }
  };
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  const formatMoney = (cents) => {
    const fmt = T.moneyFormat || '₹{{amount}}';
    const value = (Number(cents) / 100);
    const withDelims = (n, dec, th = ',', d = '.') => {
      const [i, f] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? d + f : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0);
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.');
        default: return withDelims(value, 2);
      }
    });
  };

  /* ------------------------------------------------------------------
     Toast
  ------------------------------------------------------------------ */
  const toastEl = $('[data-toast]');
  let toastTimer;
  function toast(html, ms = 3500) {
    if (!toastEl) return;
    toastEl.innerHTML = html;
    requestAnimationFrame(() => toastEl.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), ms);
  }

  /* ------------------------------------------------------------------
     Drawers (menu, cart, wishlist, filters, size guide, search)
  ------------------------------------------------------------------ */
  const focusables = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  let lastFocus = null;
  let openDrawer = null;

  function trapFocus(e) {
    if (!openDrawer || e.key !== 'Tab') return;
    const items = $$(focusables, openDrawer.querySelector('.drawer__panel')).filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function isStaticDrawer(d) {
    return d.classList.contains('drawer--desktop-static') && window.matchMedia('(min-width: 990px)').matches;
  }

  function open(id, trigger) {
    const d = document.getElementById(id);
    if (!d || isStaticDrawer(d)) return;
    if (openDrawer && openDrawer !== d) close(openDrawer, false);
    lastFocus = trigger || document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    openDrawer = d;
    const target = d.querySelector('[data-predictive-input]') || d.querySelector('.drawer__panel [data-drawer-close]') || d.querySelector(focusables);
    setTimeout(() => target && target.focus({ preventScroll: true }), 60);
    d.dispatchEvent(new CustomEvent('drawer:open'));
  }

  function close(d = openDrawer, restore = true) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    $$(`[aria-controls="${d.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (openDrawer === d) openDrawer = null;
    if (!openDrawer) document.body.classList.remove('is-locked');
    if (restore && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); open(opener.dataset.drawerOpen, opener); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { const d = closer.closest('[data-drawer]'); if (d && !isStaticDrawer(d)) { e.preventDefault(); close(d); } return; }
    const cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen && $('#CartDrawer')) { e.preventDefault(); open('CartDrawer', cartOpen); return; }
    const searchOpen = e.target.closest('[data-search-open]');
    if (searchOpen && $('#SearchModal')) { e.preventDefault(); open('SearchModal', searchOpen); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && openDrawer) close();
    trapFocus(e);
    if ((e.key === '/' || (e.key === 'k' && (e.metaKey || e.ctrlKey))) && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) {
      if ($('#SearchModal')) { e.preventDefault(); open('SearchModal'); }
    }
  });

  /* ------------------------------------------------------------------
     Header: scroll state + desktop mega menu hover/close
  ------------------------------------------------------------------ */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    const details = $$('[data-nav-details]', header);
    details.forEach((d) => {
      let t;
      const item = d.parentElement;
      if (window.matchMedia('(hover: hover)').matches) {
        item.addEventListener('mouseenter', () => { clearTimeout(t); details.forEach((o) => o !== d && o.removeAttribute('open')); d.setAttribute('open', ''); });
        item.addEventListener('mouseleave', () => { t = setTimeout(() => d.removeAttribute('open'), 160); });
      }
      d.addEventListener('toggle', () => { if (d.open) details.forEach((o) => o !== d && o.removeAttribute('open')); });
    });
    document.addEventListener('click', (e) => { if (!e.target.closest('[data-nav-details]')) details.forEach((d) => d.removeAttribute('open')); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') details.forEach((d) => { if (d.open) { d.removeAttribute('open'); d.querySelector('summary').focus(); } }); });
  }

  /* ------------------------------------------------------------------
     Announcement bar rotation
  ------------------------------------------------------------------ */
  $$('[data-announce]').forEach((bar) => {
    const items = $$('.announce__item', bar);
    if (items.length < 2) return;
    let i = 0, timer;
    const show = (n) => {
      items[i].hidden = true; items[i].classList.remove('is-active');
      i = (n + items.length) % items.length;
      items[i].hidden = false; items[i].classList.add('is-active', 'is-entering');
      setTimeout(() => items[i].classList.remove('is-entering'), 600);
    };
    const speed = (Number(bar.dataset.speed) || 5) * 1000;
    const play = () => { if (!reducedMotion) { clearInterval(timer); timer = setInterval(() => show(i + 1), speed); } };
    const pause = () => clearInterval(timer);
    $('[data-announce-next]', bar)?.addEventListener('click', () => { show(i + 1); play(); });
    $('[data-announce-prev]', bar)?.addEventListener('click', () => { show(i - 1); play(); });
    bar.addEventListener('mouseenter', pause); bar.addEventListener('mouseleave', play);
    bar.addEventListener('focusin', pause); bar.addEventListener('focusout', play);
    play();
  });

  /* ------------------------------------------------------------------
     Reveal on scroll
  ------------------------------------------------------------------ */
  function initReveal(root = document) {
    const els = $$('[data-reveal]:not(.is-revealed)', root);
    if (!T.animations || reducedMotion || !('IntersectionObserver' in window)) {
      document.documentElement.classList.add('no-reveal'); return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-revealed'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
    els.forEach((el) => io.observe(el));
  }
  initReveal();

  /* ------------------------------------------------------------------
     Cart (AJAX + Section Rendering)
  ------------------------------------------------------------------ */
  const Cart = {
    sections() {
      const s = ['cart-count'];
      if ($('#CartDrawer')) s.push('cart-drawer');
      const page = $('[data-cart-page]');
      if (page && page.dataset.sectionId) s.push(page.dataset.sectionId);
      return s;
    },
    async request(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: this.sections(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.cartError);
      return data;
    },
    render(sections) {
      if (!sections) return;
      const page = $('[data-cart-page]');
      if (page && sections[page.dataset.sectionId]) {
        const freshPage = parseHTML(sections[page.dataset.sectionId]).querySelector('[data-cart-page]');
        if (freshPage) page.innerHTML = freshPage.innerHTML;
      }
      const freshCount = sections['cart-count'] && parseHTML(sections['cart-count']).querySelector('[data-cart-count]');
      if (freshCount) {
        $$('[data-cart-count]').forEach((el) => {
          el.replaceWith(freshCount.cloneNode(true));
        });
        $$('[data-cart-count]').forEach((el) => { el.classList.add('is-bump'); setTimeout(() => el.classList.remove('is-bump'), 500); });
      }
      if (sections['cart-drawer']) {
        const doc = parseHTML(sections['cart-drawer']);
        const newBody = doc.querySelector('[data-cart-body]');
        const newTitle = doc.querySelector('#CartDrawer .drawer__title');
        const body = $('#CartDrawer [data-cart-body]');
        if (body && newBody) {
          const openDetails = $$('details[open]', body).map((d) => d.querySelector('summary')?.textContent.trim());
          body.innerHTML = newBody.innerHTML;
          $$('details', body).forEach((d) => { if (openDetails.includes(d.querySelector('summary')?.textContent.trim())) d.open = true; });
        }
        const title = $('#CartDrawer .drawer__title');
        if (title && newTitle) title.innerHTML = newTitle.innerHTML;
      }
    },
    async add(items, trigger) {
      const data = await this.request(`${T.routes.cartAdd}.js`, { items });
      this.render(data.sections);
      return data;
    },
    async change(line, quantity) {
      const root = $$('[data-cart-root]');
      root.forEach((r) => r.classList.add('is-updating'));
      try {
        const data = await this.request(`${T.routes.cartChange}.js`, { line, quantity });
        this.render(data.sections);
        } catch (err) { toast(err.message); }
      finally { $$('[data-cart-root]').forEach((r) => r.classList.remove('is-updating')); }
    },
    async update(body) {
      const data = await this.request(`${T.routes.cartUpdate}.js`, body);
      this.render(data.sections);
      return data;
    },
    afterAdd(data, trigger) {
      if (T.cartType === 'drawer' && $('#CartDrawer')) {
        const qv = $('#QuickView');
        if (qv && qv.open) qv.close();
        open('CartDrawer', trigger);
      } else {
        const item = (data.items && data.items[0]) || data;
        const img = item.image ? `<img src="${item.image.replace(/(\.[a-z]+)(\?|$)/i, '_80x$1$2')}" alt="">` : '';
        toast(`${img}<span>${T.strings.added}</span><a class="btn btn--light" href="${T.routes.cart}">${document.querySelector('.header__cart')?.getAttribute('aria-label') || 'Cart'}</a>`);
      }
    }
  };

  // Product forms (PDP, quick view, quick add chips, upsells)
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = e.submitter || form.querySelector('[type="submit"]');
    const errorEl = form.querySelector('[data-form-error]');
    if (errorEl) errorEl.hidden = true;
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    if (!id) return;
    const quantity = Number(fd.get('quantity') || 1);
    const properties = {};
    for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m) properties[m[1]] = v; }
    btn && btn.classList.add('is-loading');
    btn && btn.setAttribute('aria-busy', 'true');
    try {
      const data = await Cart.add([{ id, quantity, properties }], btn);
      btn && btn.classList.add('is-added');
      setTimeout(() => btn && btn.classList.remove('is-added'), 1600);
      const scope = form.closest('[data-product-section], [data-product-card], .upsell__item');
      const srcImg = scope && (scope.querySelector('.gallery__slide.is-active img, .card__img--primary, .qv__track img, .upsell__media img') || scope.querySelector('img'));
      const flew = window.kqFly ? window.kqFly(srcImg) : false;
      setTimeout(() => Cart.afterAdd(data, btn), flew ? 650 : 0);
    } catch (err) {
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } else toast(err.message);
    } finally {
      btn && btn.classList.remove('is-loading');
      btn && btn.removeAttribute('aria-busy');
    }
  });

  // Quantity steppers (PDP + cart)
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-change]');
    if (step) {
      const input = step.closest('[data-qty]').querySelector('input');
      const min = Number(input.min || 0);
      const next = Math.max(min, Number(input.value || 0) + Number(step.dataset.qtyChange));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) {
      const line = rm.closest('.line');
      line && line.classList.add('is-removing');
      setTimeout(() => Cart.change(Number(rm.dataset.lineRemove), 0), 250);
      return;
    }
    const dr = e.target.closest('[data-discount-remove]');
    if (dr) {
      e.preventDefault();
      const remaining = $$('[data-discount-remove]', dr.closest('.chip-row')).map((c) => c.dataset.discountRemove).filter((c) => c !== dr.dataset.discountRemove);
      Cart.update({ discount: remaining.join(',') }).catch((err) => toast(err.message));
    }
  });

  document.addEventListener('change', debounce((e) => {
    const input = e.target.closest('[data-line-qty]');
    if (input) Cart.change(Number(input.dataset.lineQty), Math.max(0, Number(input.value)));
  }, 350));

  document.addEventListener('input', debounce((e) => {
    const note = e.target.closest('[data-cart-note]');
    if (note) fetch(`${T.routes.cartUpdate}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  }, 600));

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    const input = form.querySelector('input');
    const code = input.value.trim();
    if (!code) return;
    const existing = $$('[data-discount-remove]', form.closest('.cart-foot')).map((c) => c.dataset.discountRemove);
    const msg = form.parentElement.querySelector('[data-discount-msg]');
    try {
      const data = await Cart.update({ discount: [...existing, code].join(',') });
      const applied = (data.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
      if (applied && !applied.applicable) {
        const m = $('#CartDrawer [data-discount-msg]') || msg;
        if (m) m.textContent = T.strings.discountInvalid.replace('[code]', code);
      }
    } catch (err) { if (msg) msg.textContent = err.message; }
  });

  /* ------------------------------------------------------------------
     Product section: variants, gallery, zoom, sticky ATC
  ------------------------------------------------------------------ */
  function initProduct(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = '1';
    const jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const isQuick = section.hasAttribute('data-quick');
    const form = section.querySelector('[data-main-form]');
    const idInput = form && form.querySelector('[data-variant-id]');
    const addBtn = section.querySelector('[data-add-button]');
    const addLabel = section.querySelector('[data-add-label]');
    const stickyBar = !isQuick && section.querySelector('[data-sticky-atc]');

    const currentOptions = () => {
      const radios = $$('input[data-option-index]:checked', section);
      return radios.sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex).map((r) => r.value);
    };

    function update() {
      const opts = currentOptions();
      const variant = product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      opts.forEach((val, i) => { const el = section.querySelector(`[data-option-value="${i}"]`); if (el) el.textContent = val; });
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addLabel.textContent = T.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (addBtn) { addBtn.disabled = !variant.available; addLabel.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut; }

      const priceWrap = section.querySelector('[data-price-wrap] [data-price]');
      if (priceWrap) {
        const onSale = variant.compare_at_price > variant.price;
        priceWrap.classList.toggle('price--sale', onSale);
        const cur = priceWrap.querySelector('.price__current');
        if (cur) cur.textContent = formatMoney(variant.price);
        let cmp = priceWrap.querySelector('.price__compare');
        let save = priceWrap.querySelector('.price__save');
        if (onSale) {
          if (!cmp) { cmp = document.createElement('s'); cmp.className = 'price__compare'; priceWrap.appendChild(cmp); }
          cmp.textContent = formatMoney(variant.compare_at_price);
          if (!save) { save = document.createElement('span'); save.className = 'price__save'; priceWrap.appendChild(save); }
          save.textContent = T.strings.savePercent.replace('[p]', Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price));
        } else { cmp && cmp.remove(); save && save.remove(); }
      }
      const sku = section.querySelector('[data-sku]');
      if (sku) sku.textContent = variant.sku || '—';
      const stock = section.querySelector('[data-stock-note]');
      if (stock) stock.hidden = true;

      if (!isQuick) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
        if (variant.featured_media) goTo(variant.featured_media.id);
      }
      if (stickyBar) {
        const sv = stickyBar.querySelector('[data-sticky-variant]');
        if (sv) sv.textContent = product.variants.length > 1 ? `${variant.title} · ` : '';
        stickyBar.querySelector('[data-sticky-price]').textContent = formatMoney(variant.price);
        const sb = stickyBar.querySelector('[data-sticky-add]');
        sb.disabled = !variant.available;
        sb.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;
      }
    }
    section.addEventListener('change', (e) => { if (e.target.matches('input[data-option-index]')) update(); });

    // Gallery
    const track = section.querySelector('[data-gallery-track]');
    const thumbs = $$('[data-thumb]', section);
    const dots = $$('.gallery__dots span', section);
    const counter = section.querySelector('[data-gallery-current]');
    const gbar = section.querySelector('[data-gallery-bar]');
    function setActive(idx) {
      thumbs.forEach((t, i) => { t.classList.toggle('is-active', i === idx); if (i === idx) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      if (track) $$('.gallery__slide', track).forEach((sl, i) => sl.classList.toggle('is-active', i === idx));
      if (counter) counter.textContent = idx + 1;
      if (gbar) gbar.style.setProperty('--gx', `${idx * 100}%`);
    }
    function goTo(mediaIdOrIndex) {
      if (!track) return;
      const slides = $$('.gallery__slide', track);
      const idx = typeof mediaIdOrIndex === 'number' && mediaIdOrIndex < slides.length
        ? mediaIdOrIndex
        : slides.findIndex((s) => Number(s.dataset.mediaId) === Number(mediaIdOrIndex));
      if (idx < 0) return;
      if (window.matchMedia('(min-width: 990px)').matches) slides[idx].scrollIntoView({ block: 'center', behavior: reducedMotion ? 'auto' : 'smooth' });
      else track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
      setActive(idx);
    }
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.thumb))));
    if (track) {
      track.addEventListener('scroll', debounce(() => {
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        setActive(idx);
      }, 60), { passive: true });

      // Hover zoom (desktop) + click to open lightbox
      if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
        $$('.gallery__zoom', track).forEach((z) => {
          const img = z.querySelector('img');
          z.addEventListener('mousemove', (e) => {
            const r = z.getBoundingClientRect();
            img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
          });
          z.addEventListener('mouseenter', () => z.classList.add('is-zooming'));
          z.addEventListener('mouseleave', () => z.classList.remove('is-zooming'));
        });
      }
      const lb = section.querySelector('[data-lightbox]');
      $$('[data-zoom-open]', track).forEach((z) => z.addEventListener('click', () => {
        if (!lb) return;
        lb.showModal();
        document.body.classList.add('is-locked');
        const target = lb.querySelector(`[data-lightbox-item="${z.dataset.zoomOpen}"]`);
        target && target.scrollIntoView({ block: 'start' });
      }));
      if (lb) {
        lb.addEventListener('click', (e) => { if (e.target.closest('[data-close]') || e.target.closest('.lightbox__item')) lb.close(); });
        lb.addEventListener('close', () => document.body.classList.remove('is-locked'));
      }
    }

    // Sticky add-to-cart
    if (stickyBar && addBtn) {
      const io = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', String(!show));
        stickyBar.querySelector('[data-sticky-add]').tabIndex = show ? 0 : -1;
      });
      io.observe(addBtn);
      stickyBar.querySelector('[data-sticky-add]').addEventListener('click', (e) => {
        const needsChoice = product.variants.length > 1 && !$$('input[data-option-index]:checked', section).length;
        if (needsChoice) { section.querySelector('[data-variant-picker]').scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        form.requestSubmit(addBtn);
      });
    }

    // Share
    section.querySelector('[data-share]')?.addEventListener('click', async (e) => {
      const b = e.currentTarget;
      if (navigator.share) { try { await navigator.share({ title: b.dataset.title, url: b.dataset.url }); } catch (err) { /* cancelled */ } }
      else { try { await navigator.clipboard.writeText(b.dataset.url); toast(T.strings.linkCopied); } catch (err) { /* clipboard blocked */ } }
    });

    if (!isQuick) RecentlyViewed.add(section.dataset.productHandle);
  }

  /* ------------------------------------------------------------------
     Quick view
  ------------------------------------------------------------------ */
  const qv = $('#QuickView');
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-view]');
    if (!btn || !qv) return;
    e.preventDefault();
    const body = qv.querySelector('[data-quick-view-body]');
    body.innerHTML = '';
    body.classList.add('is-loading');
    if (openDrawer) close(openDrawer, false);
    qv.showModal();
    document.body.classList.add('is-locked');
    lastFocus = btn;
    try {
      const url = btn.dataset.quickView.split('?')[0];
      const html = await (await fetch(`${url}?section_id=quick-view`)).text();
      const node = parseHTML(html).querySelector('[data-product-section]');
      body.classList.remove('is-loading');
      if (node) { body.appendChild(node); initProduct(node); Wishlist.sync(); }
      qv.querySelector('.pill') ? qv.querySelector('.pill__input:checked')?.focus() : qv.querySelector('[data-close]').focus();
    } catch (err) { body.classList.remove('is-loading'); body.textContent = T.strings.cartError; }
  });
  if (qv) {
    qv.addEventListener('click', (e) => { if (e.target === qv || e.target.closest('[data-close]')) qv.close(); });
    qv.addEventListener('close', () => { document.body.classList.remove('is-locked'); lastFocus && lastFocus.focus({ preventScroll: true }); });
  }

  /* ------------------------------------------------------------------
     Wishlist (browser storage) + drawer
  ------------------------------------------------------------------ */
  const WL_KEY = 'kq:wishlist';
  const cardCache = new Map();
  async function fetchCard(handle) {
    if (cardCache.has(handle)) return cardCache.get(handle);
    const p = fetch(`${T.routes.root.replace(/\/$/, '')}/products/${handle}?section_id=card-fragment`)
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => { const card = html && parseHTML(html).querySelector('[data-product-card]'); return card ? card.outerHTML : ''; })
      .catch(() => '');
    cardCache.set(handle, p);
    return p;
  }

  const Wishlist = {
    list() { return store.get(WL_KEY, []); },
    has(h) { return this.list().includes(h); },
    toggle(h) {
      let l = this.list();
      l = l.includes(h) ? l.filter((x) => x !== h) : [h, ...l].slice(0, 50);
      store.set(WL_KEY, l);
      this.sync();
      return l.includes(h);
    },
    sync() {
      const l = this.list();
      $$('[data-wishlist-toggle]').forEach((b) => {
        const on = l.includes(b.dataset.wishlistToggle);
        b.setAttribute('aria-pressed', String(on));
        const lab = b.getAttribute('aria-label') || '';
        const title = lab.includes(':') ? lab.split(':').slice(1).join(':') : '';
        b.setAttribute('aria-label', `${on ? T.strings.wishlistRemove : T.strings.wishlistAdd}${title ? ':' + title : ''}`);
        const t = b.querySelector('[data-wishlist-label]'); if (t) t.textContent = on ? T.strings.wishlistRemove : T.strings.wishlistAdd;
      });
      $$('[data-wishlist-count]').forEach((c) => { c.textContent = l.length; c.hidden = l.length === 0; });
      $$('[data-wishlist-count-text]').forEach((c) => { c.textContent = l.length ? `(${l.length})` : ''; });
    },
    async renderDrawer() {
      const wrap = $('[data-wishlist-items]');
      const empty = $('[data-wishlist-empty]');
      if (!wrap) return;
      const l = this.list();
      empty.hidden = l.length > 0;
      wrap.innerHTML = '';
      const cards = await Promise.all(l.map(fetchCard));
      wrap.innerHTML = cards.filter(Boolean).join('');
      this.sync();
    }
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    const added = Wishlist.toggle(b.dataset.wishlistToggle);
    $$('[data-wishlist-count]').forEach((c) => { c.classList.add('is-bump'); setTimeout(() => c.classList.remove('is-bump'), 500); });
    if (b.closest('[data-wishlist-drawer]')) Wishlist.renderDrawer();
    else toast(`<span>${added ? T.strings.wishlistSaved : T.strings.wishlistRemoved}</span>${added ? `<button class="btn btn--light" data-drawer-open="WishlistDrawer">${T.strings.view}</button>` : ''}`, 2600);
  });
  $('#WishlistDrawer')?.addEventListener('drawer:open', () => Wishlist.renderDrawer());
  Wishlist.sync();

  /* ------------------------------------------------------------------
     Recently viewed
  ------------------------------------------------------------------ */
  const RV_KEY = 'kq:recent';
  const RecentlyViewed = {
    list() { return store.get(RV_KEY, []); },
    add(h) { if (!h) return; store.set(RV_KEY, [h, ...this.list().filter((x) => x !== h)].slice(0, 12)); },
    async render() {
      const current = $('[data-product-section]:not([data-quick])')?.dataset.productHandle;
      const handles = this.list().filter((h) => h !== current);
      $$('[data-recently-viewed]').forEach(async (sec) => {
        if (!handles.length) return;
        const limit = Number(sec.dataset.limit) || 4;
        const cards = (await Promise.all(handles.slice(0, limit).map(fetchCard))).filter(Boolean);
        if (!cards.length) return;
        sec.querySelector('[data-rv-list]').innerHTML = cards.map((c) => `<li>${c}</li>`).join('');
        sec.hidden = false;
        Wishlist.sync();
        sec.querySelector('[data-rv-clear]')?.addEventListener('click', () => { store.set(RV_KEY, []); sec.hidden = true; });
      });
    }
  };
  if ('requestIdleCallback' in window) requestIdleCallback(() => RecentlyViewed.render()); else setTimeout(() => RecentlyViewed.render(), 400);

  /* ------------------------------------------------------------------
     Predictive search
  ------------------------------------------------------------------ */
  const RS_KEY = 'kq:searches';
  const searchModal = $('#SearchModal');
  if (searchModal) {
    const input = $('#PredictiveInput', searchModal);
    const results = $('[data-predictive-results]', searchModal);
    const idle = $('[data-search-idle]', searchModal);
    const recentWrap = $('[data-recent-wrap]', searchModal);
    const recentList = $('[data-recent-list]', searchModal);
    let controller, activeIndex = -1;

    const renderRecent = () => {
      const l = store.get(RS_KEY, []);
      recentWrap.hidden = !l.length;
      recentList.innerHTML = l.map((t) => `<a class="chip" href="${T.routes.search}?q=${encodeURIComponent(t)}&options%5Bprefix%5D=last">${t.replace(/</g, '&lt;')}</a>`).join('');
    };
    const renderRV = async () => {
      const wrap = $('[data-rv-search]', searchModal);
      const l = RecentlyViewed.list().slice(0, 4);
      if (!wrap || !l.length) return;
      const cards = (await Promise.all(l.map(fetchCard))).filter(Boolean);
      $('[data-rv-search-list]', wrap).innerHTML = cards.join('');
      wrap.hidden = !cards.length;
    };
    searchModal.addEventListener('drawer:open', () => { renderRecent(); renderRV(); });
    $('[data-recent-clear]', searchModal)?.addEventListener('click', () => { store.set(RS_KEY, []); renderRecent(); });

    const options = () => $$('[role="option"]', results);
    const setActive = (i) => {
      const opts = options();
      opts.forEach((o) => o.setAttribute('aria-selected', 'false'));
      activeIndex = i;
      if (opts[i]) { opts[i].setAttribute('aria-selected', 'true'); input.setAttribute('aria-activedescendant', opts[i].id); opts[i].scrollIntoView({ block: 'nearest' }); }
      else input.removeAttribute('aria-activedescendant');
    };

    const search = debounce(async (q) => {
      if (controller) controller.abort();
      if (!q) { results.innerHTML = ''; idle.hidden = false; input.setAttribute('aria-expanded', 'false'); return; }
      controller = new AbortController();
      try {
        const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,query,page&resources[limit]=6&resources[options][unavailable_products]=last`;
        const html = await (await fetch(url, { signal: controller.signal })).text();
        const node = parseHTML(html).querySelector('.ps');
        results.innerHTML = node ? node.outerHTML : '';
        idle.hidden = true;
        input.setAttribute('aria-expanded', 'true');
        activeIndex = -1;
      } catch (err) { /* aborted */ }
    }, 180);

    if (input && input.hasAttribute('data-predictive-input')) {
      input.addEventListener('input', () => search(input.value.trim()));
      input.addEventListener('keydown', (e) => {
        const opts = options();
        if (e.key === 'ArrowDown') { e.preventDefault(); setActive(Math.min(activeIndex + 1, opts.length - 1)); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(activeIndex - 1, -1)); }
        else if (e.key === 'Enter' && activeIndex >= 0 && opts[activeIndex]) { e.preventDefault(); opts[activeIndex].querySelector('a').click(); }
      });
    }
    $('[data-predictive-form]', searchModal)?.addEventListener('submit', () => {
      const q = input.value.trim();
      if (q) store.set(RS_KEY, [q, ...store.get(RS_KEY, []).filter((t) => t.toLowerCase() !== q.toLowerCase())].slice(0, 6));
    });
  }

  /* ------------------------------------------------------------------
     Tabs (product tabs section)
  ------------------------------------------------------------------ */
  $$('[data-tabs]').forEach((wrap) => {
    const tabs = $$('[role="tab"]', wrap);
    const activate = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        panel.hidden = !on;
        if (on) { panel.classList.add('is-entering'); setTimeout(() => panel.classList.remove('is-entering'), 500); initReveal(panel); $$('[data-reveal]', panel).forEach((el) => el.classList.add('is-revealed')); }
      });
      if (focus) tab.focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => activate(t));
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') activate(tabs[(i + 1) % tabs.length], true);
        if (e.key === 'ArrowLeft') activate(tabs[(i - 1 + tabs.length) % tabs.length], true);
      });
    });
  });

  /* ------------------------------------------------------------------
     Interactive details (craft) — auto-advancing accordion + image swap
  ------------------------------------------------------------------ */
  $$('[data-craft]').forEach((sec) => {
    const btns = $$('[data-craft-btn]', sec);
    const figs = $$('[data-craft-fig]', sec);
    const items = $$('.craft__item', sec);
    const dur = 6000;
    sec.style.setProperty('--craft-dur', `${dur}ms`);
    let i = 0, timer, visible = false, userTook = false;
    const show = (n) => {
      i = n;
      items.forEach((it, k) => {
        const on = k === n;
        it.classList.toggle('is-active', on);
        btns[k].setAttribute('aria-expanded', String(on));
        it.querySelector('.craft__a').hidden = !on;
        const bar = it.querySelector('.craft__bar'); if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      });
      figs.forEach((f, k) => { f.classList.toggle('is-active', k === n); f.setAttribute('aria-hidden', String(k !== n)); });
    };
    const loop = () => { clearInterval(timer); if (!reducedMotion && visible && !userTook) timer = setInterval(() => show((i + 1) % btns.length), dur); };
    btns.forEach((b, k) => b.addEventListener('click', () => { userTook = true; clearInterval(timer); sec.classList.add('is-paused'); show(k); }));
    sec.addEventListener('mouseenter', () => { clearInterval(timer); sec.classList.add('is-paused'); });
    sec.addEventListener('mouseleave', () => { if (!userTook) { sec.classList.remove('is-paused'); loop(); } });
    new IntersectionObserver(([en]) => { visible = en.isIntersecting; loop(); }, { threshold: .35 }).observe(sec);
  });

  /* ------------------------------------------------------------------
     Shop the look hotspots
  ------------------------------------------------------------------ */
  $$('[data-look]').forEach((sec) => {
    const dots = $$('[data-look-dot]', sec);
    const items = $$('[data-look-item]', sec);
    const set = (n) => {
      dots.forEach((d) => d.classList.toggle('is-active', d.dataset.lookDot === String(n)));
      items.forEach((it) => it.classList.toggle('is-active', it.dataset.lookItem === String(n)));
    };
    dots.forEach((d) => { d.addEventListener('click', () => set(d.dataset.lookDot)); d.addEventListener('mouseenter', () => set(d.dataset.lookDot)); });
    items.forEach((it) => it.addEventListener('mouseenter', () => set(it.dataset.lookItem)));
  });

  /* ------------------------------------------------------------------
     Read more clamps
  ------------------------------------------------------------------ */
  $$('[data-clamp]').forEach((el) => {
    const btn = el.parentElement.querySelector('[data-clamp-toggle]');
    if (el.scrollHeight <= el.clientHeight + 10) { el.classList.add('is-short'); btn && (btn.hidden = true); return; }
    btn && btn.addEventListener('click', () => {
      const openNow = !el.classList.contains('is-open');
      el.classList.toggle('is-open', openNow);
      el.style.maxHeight = openNow ? `${el.scrollHeight}px` : '';
      btn.textContent = openNow ? btn.dataset.less : btn.dataset.more;
      btn.setAttribute('aria-expanded', String(openNow));
    });
  });

  /* ------------------------------------------------------------------
     Product recommendations (lazy) + bundle
  ------------------------------------------------------------------ */
  $$('[data-recs]').forEach((sec) => {
    const load = async () => {
      try {
        const html = await (await fetch(sec.dataset.url)).text();
        const fresh = parseHTML(html).querySelector('[data-recs]');
        if (fresh && fresh.innerHTML.trim()) { sec.innerHTML = fresh.innerHTML; initBundle(sec); Wishlist.sync(); initReveal(sec); }
        else sec.remove();
      } catch (e) { sec.remove(); }
    };
    new IntersectionObserver(([en], io) => { if (en.isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' }).observe(sec);
  });

  function initBundle(root) {
    const b = root.querySelector('[data-bundle]');
    if (!b) return;
    const total = b.querySelector('[data-bundle-total]');
    const calc = () => {
      let sum = 0, n = 0;
      $$('.bundle__item', b).forEach((it) => {
        const on = it.querySelector('[data-bundle-check]').checked;
        it.classList.toggle('is-off', !on);
        if (!on) return;
        const v = it.querySelector('[data-bundle-variant]');
        const opt = v.tagName === 'SELECT' ? v.selectedOptions[0] : v;
        sum += Number(opt.dataset.price || 0); n += 1;
      });
      total.textContent = formatMoney(sum);
      b.querySelector('[data-bundle-add]').disabled = n === 0;
    };
    b.addEventListener('change', calc);
    calc();
    b.querySelector('[data-bundle-add]').addEventListener('click', async (e) => {
      const btn = e.currentTarget;
      const items = $$('.bundle__item', b).filter((it) => it.querySelector('[data-bundle-check]').checked)
        .map((it) => ({ id: Number(it.querySelector('[data-bundle-variant]').value), quantity: 1 }));
      if (!items.length) return;
      btn.classList.add('is-loading');
      try { const data = await Cart.add(items, btn); Cart.afterAdd(data, btn); }
      catch (err) { toast(err.message); }
      finally { btn.classList.remove('is-loading'); }
    });
  }

  /* ------------------------------------------------------------------
     Collection & search: AJAX filtering, sorting, load more, density
  ------------------------------------------------------------------ */
  $$('[data-collection]').forEach((sec) => {
    const sectionId = sec.dataset.sectionId;

    const replaceFrom = (doc) => {
      const fresh = doc.querySelector('[data-results-root]');
      const cur = sec.querySelector('[data-results-root]');
      if (!fresh || !cur) return;
      const openFacets = $$('.facet', cur).map((f) => f.open);
      const drawerOpen = $('#FilterDrawer')?.classList.contains('is-open');
      const density = cur.dataset.densityGrid;
      cur.replaceWith(fresh);
      $$('.facet', fresh).forEach((f, i) => { if (openFacets[i] !== undefined) f.open = openFacets[i]; });
      if (density) applyDensity(density);
      if (drawerOpen) { const d = $('#FilterDrawer'); d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); openDrawer = d; }
      Wishlist.sync();
      initReveal(fresh);
    };

    async function go(url, push = true) {
      const u = new URL(url, window.location.origin);
      u.searchParams.delete('page');
      sec.classList.add('is-filtering');
      try {
        const fetchUrl = new URL(u); fetchUrl.searchParams.set('section_id', sectionId);
        const html = await (await fetch(fetchUrl)).text();
        replaceFrom(parseHTML(html));
        if (push) window.history.pushState({ kq: true }, '', u.toString());
        const count = sec.querySelector('[data-results-count]');
        if (count) count.setAttribute('aria-live', 'polite');
      } finally { sec.classList.remove('is-filtering'); }
    }

    const formUrl = (form) => {
      const fd = new FormData(form);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) if (v !== '') params.append(k, v);
      return `${form.getAttribute('action')}?${params.toString()}`;
    };

    sec.addEventListener('change', debounce((e) => {
      const form = e.target.closest('[data-facets-form]');
      if (form) go(formUrl(form));
      if (e.target.matches('[data-sort-select]')) {
        const f = sec.querySelector('[data-facets-form]');
        if (f) { f.querySelector('[data-sort-hidden]').value = e.target.value; go(formUrl(f)); }
        else { const u = new URL(window.location.href); u.searchParams.set('sort_by', e.target.value); go(u.toString()); }
      }
    }, 300));
    sec.addEventListener('submit', (e) => { const f = e.target.closest('[data-facets-form]'); if (f) { e.preventDefault(); go(formUrl(f)); } });
    sec.addEventListener('click', async (e) => {
      const link = e.target.closest('[data-facet-link]');
      if (link) { e.preventDefault(); go(link.href); return; }
      const more = e.target.closest('[data-load-more]');
      if (more) {
        e.preventDefault();
        more.classList.add('is-loading');
        try {
          const u = new URL(more.href); u.searchParams.set('section_id', sectionId);
          const doc = parseHTML(await (await fetch(u)).text());
          const grid = sec.querySelector('[data-product-grid]');
          const items = $$('[data-product-grid] > li', doc);
          const firstNew = items[0];
          items.forEach((li) => grid.appendChild(li));
          const wrap = sec.querySelector('[data-load-more-wrap]');
          const freshWrap = doc.querySelector('[data-load-more-wrap]');
          if (wrap && freshWrap) wrap.replaceWith(freshWrap);
          Wishlist.sync();
          initReveal(grid);
          const focusTarget = firstNew && firstNew.querySelector('.card__title a');
          focusTarget && focusTarget.focus({ preventScroll: true });
        } finally { more.classList.remove('is-loading'); }
        return;
      }
      const dens = e.target.closest('[data-density]');
      if (dens) { applyDensity(dens.dataset.density); store.set('kq:density', dens.dataset.density); }
    });

    function applyDensity(n) {
      const root = sec.querySelector('[data-results-root]');
      if (!root) return;
      root.dataset.densityGrid = n;
      $$('[data-density]', root).forEach((b) => { const on = b.dataset.density === String(n); b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on)); });
    }
    applyDensity(store.get('kq:density', '3'));

    window.addEventListener('popstate', () => go(window.location.href, false));
  });

  /* ------------------------------------------------------------------
     Misc: login recover toggle, address country default
  ------------------------------------------------------------------ */
  $$('[data-toggle-recover]').forEach((a) => a.addEventListener('click', (e) => {
    e.preventDefault();
    $('[data-login-panel]').hidden = !$('[data-login-panel]').hidden;
    $('[data-recover-panel]').hidden = !$('[data-recover-panel]').hidden;
  }));
  if (location.hash === '#recover' && $('[data-recover-panel]')) { $('[data-login-panel]').hidden = true; $('[data-recover-panel]').hidden = false; }
  $$('select[data-default]').forEach((s) => { if (s.dataset.default) s.value = s.dataset.default; });

  // Keep header/cart state fresh when returning via back/forward cache
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    Wishlist.sync();
    fetch(`${T.routes.root.replace(/\/$/, '')}/?sections=cart-count`).then((r) => r.json()).then((s) => Cart.render(s)).catch(() => {});
  });
  /* ==================================================================
     Interactive layer v2
  ================================================================== */
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

  // One rAF-throttled scroll loop for every scroll-linked effect
  const scrollFns = new Set();
  let ticking = false;
  const runScroll = () => { ticking = false; const y = window.scrollY; scrollFns.forEach((fn) => fn(y)); };
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(runScroll); } }, { passive: true });
  window.addEventListener('resize', debounce(runScroll, 120));

  // Scroll progress + header that hides on the way down
  const progressEl = $('[data-scroll-progress]');
  const headerWrap = $('.section-header');
  let lastY = window.scrollY;
  scrollFns.add((y) => {
    const max = document.documentElement.scrollHeight - window.innerHeight;
    if (progressEl) progressEl.parentElement.style.setProperty('--sp', max > 0 ? (y / max).toFixed(4) : 0);
    if (!headerWrap || Math.abs(y - lastY) < 6) return;
    const menuOpen = $('[data-nav-details][open]') || openDrawer;
    const hide = y > lastY && y > 320 && !menuOpen && !reducedMotion;
    headerWrap.classList.toggle('is-hidden', hide);
    document.documentElement.style.setProperty('--hdr', hide ? '0px' : 'var(--header-h)');
    lastY = y;
  });

  // Drag carousel with momentum
  $$('[data-drag]').forEach((vp) => {
    const sec = vp.closest('section');
    const bar = $('[data-drag-bar]', sec);
    const prev = $('[data-drag-prev]', sec), next = $('[data-drag-next]', sec);
    let down = false, startX = 0, startL = 0, moved = 0, vel = 0, lastX = 0, raf;
    const upd = () => {
      const max = vp.scrollWidth - vp.clientWidth;
      const w = clamp(vp.clientWidth / vp.scrollWidth, 0.08, 1);
      const p = max > 0 ? vp.scrollLeft / max : 0;
      if (bar) { bar.style.setProperty('--pw', `${(w * 100).toFixed(2)}%`); bar.style.setProperty('--px', `${(p * (1 / w - 1) * 100).toFixed(2)}%`); }
      if (prev) prev.disabled = vp.scrollLeft < 4;
      if (next) next.disabled = vp.scrollLeft > max - 4;
    };
    vp.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', debounce(upd, 150));
    upd();
    vp.addEventListener('dragstart', (e) => e.preventDefault());
    vp.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('button, form')) return;
      down = true; moved = 0; startX = lastX = e.clientX; startL = vp.scrollLeft; vel = 0; cancelAnimationFrame(raf);
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      if (moved > 6) vp.classList.add('is-dragging');
      vel = e.clientX - lastX; lastX = e.clientX;
      vp.scrollLeft = startL - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!down) return;
      down = false;
      const glide = () => { vel *= 0.92; vp.scrollLeft -= vel; if (Math.abs(vel) > 0.4) raf = requestAnimationFrame(glide); else vp.classList.remove('is-dragging'); };
      if (moved > 6 && !reducedMotion) glide(); else vp.classList.remove('is-dragging');
    });
    vp.addEventListener('click', (e) => { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    const step = () => { const item = vp.querySelector('li'); return item ? (item.offsetWidth + 20) * 2 : vp.clientWidth * 0.8; };
    prev && prev.addEventListener('click', () => vp.scrollBy({ left: -step(), behavior: reducedMotion ? 'auto' : 'smooth' }));
    next && next.addEventListener('click', () => vp.scrollBy({ left: step(), behavior: reducedMotion ? 'auto' : 'smooth' }));
  });

  // Shared-element page transition from card image to product page
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-product-card] a[href]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || !('startViewTransition' in document)) return;
    const img = a.closest('[data-product-card]').querySelector('.card__img--primary');
    $$('.card__img').forEach((i) => { i.style.viewTransitionName = ''; });
    if (img) img.style.viewTransitionName = 'product-image';
  });
  window.addEventListener('pageshow', () => $$('.card__img').forEach((i) => { i.style.viewTransitionName = ''; }));

  // Filter popovers: one open at a time, close on outside click / Escape
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.hasAttribute('data-popover') || !d.open) return;
    $$('details[data-popover][open]').forEach((o) => { if (o !== d) o.open = false; });
  }, true);
  document.addEventListener('click', (e) => {
    if (!e.target.closest('details[data-popover]')) $$('details[data-popover][open]').forEach((o) => { o.open = false; });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const o = $('details[data-popover][open]');
    if (o) { o.open = false; o.querySelector('summary').focus(); }
  });

  // Tabs: sliding indicator
  $$('.tabs').forEach((tabsEl) => {
    const move = () => {
      const t = tabsEl.querySelector('[aria-selected="true"]');
      if (!t) return;
      tabsEl.style.setProperty('--tx', `${t.offsetLeft}px`);
      tabsEl.style.setProperty('--tw', `${t.offsetWidth}px`);
      tabsEl.classList.add('is-ready');
    };
    move();
    tabsEl.addEventListener('click', () => requestAnimationFrame(move));
    tabsEl.addEventListener('keydown', () => requestAnimationFrame(move));
    window.addEventListener('resize', debounce(move, 150));
    if (document.fonts) document.fonts.ready.then(move);
  });

  // Fly-to-bag
  window.kqFly = (from) => {
    const target = $('.header__cart');
    if (reducedMotion || !from || !target) return false;
    const src = from.currentSrc || from.src;
    if (!src) return false;
    const r = from.getBoundingClientRect();
    if (r.width === 0 || r.bottom < 0 || r.top > window.innerHeight) return false;
    const t = target.getBoundingClientRect();
    const el = document.createElement('div');
    el.className = 'fly';
    el.style.cssText = `left:${r.left}px;top:${r.top}px;width:${r.width}px;height:${r.height}px;`;
    el.innerHTML = `<img src="${src}" alt="">`;
    document.body.append(el);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      el.style.transform = `translate(${(t.left + t.width / 2) - (r.left + r.width / 2)}px, ${(t.top + t.height / 2) - (r.top + r.height / 2)}px) scale(${Math.max(28 / r.width, 0.05)})`;
      el.style.opacity = '0.3';
    }));
    setTimeout(() => el.remove(), 900);
    headerWrap && headerWrap.classList.remove('is-hidden');
    return true;
  };

  // Instagram: open posts in an on-site player (native video if uploaded, otherwise Instagram's embed)
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-ig-open]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    const sec = a.closest('[data-ig]');
    const modal = sec && sec.querySelector('[data-ig-modal]');
    if (!modal || typeof modal.showModal !== 'function') return;
    e.preventDefault();
    const body = modal.querySelector('[data-ig-body]');
    body.innerHTML = '';
    const tplId = a.dataset.igVideo;
    const tpl = tplId && document.getElementById(tplId);
    if (tpl) {
      body.append(tpl.content.cloneNode(true));
      body.classList.add('is-video');
    } else {
      body.classList.remove('is-video');
      const m = a.href.match(/\/(p|reel|tv)\/([^/?#]+)/);
      if (!m) { window.open(a.href, '_blank', 'noopener'); return; }
      const f = document.createElement('iframe');
      f.src = `https://www.instagram.com/p/${m[2]}/embed/`;
      f.title = a.getAttribute('aria-label') || 'Instagram post';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; clipboard-write';
      f.setAttribute('allowfullscreen', '');
      body.append(f);
    }
    modal.querySelector('[data-ig-link]').href = a.href;
    modal.showModal();
    document.body.classList.add('is-locked');
    lastFocus = a;
    const v = body.querySelector('video');
    if (v) v.play().catch(() => {});
  });
  $$('[data-ig-modal]').forEach((modal) => {
    modal.addEventListener('click', (e) => { if (e.target === modal || e.target.closest('[data-close]')) modal.close(); });
    modal.addEventListener('close', () => {
      modal.querySelector('[data-ig-body]').innerHTML = '';
      document.body.classList.remove('is-locked');
      lastFocus && lastFocus.focus({ preventScroll: true });
    });
  });

  // Policy pages: build an "On this page" list from the policy headings
  const toc = $('[data-policy-toc]');
  const policyBody = $('.shopify-policy__body');
  if (toc && policyBody) {
    const heads = $$('h2, h3', policyBody).filter((h) => h.textContent.trim());
    if (heads.length > 1) {
      heads.forEach((h, i) => {
        if (!h.id) h.id = `policy-${i + 1}-${h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40)}`;
        const li = document.createElement('li');
        if (h.tagName === 'H3') li.className = 'is-sub';
        const link = document.createElement('a');
        link.href = `#${h.id}`; link.textContent = h.textContent.trim();
        li.append(link); toc.append(li);
      });
      toc.closest('[data-policy-toc-wrap]').hidden = false;
      const links = $$('a', toc);
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) links.forEach((l) => l.classList.toggle('is-active', l.hash === `#${en.target.id}`));
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      heads.forEach((h) => io.observe(h));
    }
  }

  // Initialise product sections last, once every module above is defined
  $$('[data-product-section]').forEach(initProduct);

  runScroll();
})();
